import { SxProps, Theme } from '@mui/material';

export const clsx = (...styles: (SxProps<Theme> | undefined | null)[]): SxProps<Theme> =>
	(Array.isArray(styles) ? styles : [styles]).filter(Boolean).flat(Number.MAX_SAFE_INTEGER) as SxProps<Theme>;

export const clsxToObj = (...styles: (SxProps<Theme> | undefined | null)[]): SxProps<Theme> =>
	(clsx(...styles) as Array<object>).reduce(
		(acc: object, sx: object) => ({
			...acc,
			...sx,
		}),
		{}
	) as SxProps<Theme>;
